import type { ComponentProps, FC } from 'react';

import { FlowStep } from './FlowStep.tsx';

export const FlowStepWithContainer: FC<ComponentProps<typeof FlowStep>> = ({ bodyContent, ...props }) => {
  return <FlowStep {...props} bodyContent={bodyContent} />;
};
